import { useMemo } from 'react';
import { TabKey } from '@/screens/Transcript/interfaces';
import { Details, ExtractedData, Summary, Transcript, Entities } from '../Tab';

export const useWorkspaceTranscriptTabs = () => {
  return useMemo(() => {
    return [
      {
        key: TabKey.Transcript,
        title: 'Transcript',
        component: Transcript,
      },
      /*
      isInternalUser && {
        key: TabKey.Highlights,
        title: 'Highlights',
        component: Highlights,
      },
            */
      // {
      //   key: TabKey.Entities,
      //   title: 'Entities',
      //   component: Entities,
      // },
      // {
      //   key: TabKey.Summary,
      //   title: 'Summary',
      //   component: Summary,
      // },
      {
        key: TabKey.ExtractedData,
        title: 'Summary',
        component: ExtractedData,
      },
      {
        key: TabKey.Details,
        title: 'Details',
        component: Details,
      },
    ].filter(Boolean);
  }, []);
};
